




































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import MixinChartRaw from '@/plugins/podolib/services/helper/mixins/chart/raw/index';

@Component
export default class ChartRawPhaseWalkStepsDegraded extends Mixins(MixinChartRaw) {
  getData(side: string, data: string) {
    let value = this.values.computed_data[side].aggregates[data].avg.toFixed(1);
    return parseFloat(value);
  }
}
